<vx-dialog size="sm">
  <vx-dialog-header
    icon="shield-check"
    [title]="'components.reauthenticateDialog.title' | transloco"
    [description]="'components.reauthenticateDialog.description' | transloco"
    [closeLabel]="'components.dialog.closeBtn' | transloco"
    (closeRequested)="close()" />

  @if (loginFlow(); as flow) {
    <app-kratos-form-v2
      appearance="vx"
      [flow]="flow"
      [groups]="useAal2() ? ['totp', 'webauthn'] : ['password']"
      (submitFlow)="submitFlow($event)" />
  } @else {
    <div class="flex flex-col gap-3">
      <vx-skeleton class="h-9 w-full" />
      <vx-skeleton class="h-9 w-full" />
    </div>
  }
</vx-dialog>
